<template>
  <div v-if="client">
    <default-card class="my-3 pb-2">
        <template slot="title-left"> Contratante 💼 </template>
        <template slot="title-right">
          <v-btn @click="enableEditing()" text small
            :color="!is_editing ? 'normal' : 'red'" 
            class="btn-primary mb-1"
            :disabled="loading"
            v-if="is_component_show_event && !is_editing"
          >
            <v-icon left>
              mdi-pencil
            </v-icon>
            {{!is_editing ? 'Editar' : 'Cancelar'}}  
          </v-btn>
        </template>
        <template slot="content">
          <div :class="is_editing ? 'mt-n15' : 'mt-n10'">
            <v-form :disabled="!is_editing"  ref="form_contractor" v-model="valid" @submit.prevent="is_component_show_event ? submitClient() : nextStep()">
              <v-row>
                <v-col cols='12' class="mx-2 py-7 pb-3" align="right">
                  <v-btn v-if="is_editing" small dense text type="submit" class="mx-2 btn-error" align="center" @click="cancelEditing()">
                    <v-icon left>mdi-cancel</v-icon>
                    Cancelar
                  </v-btn>
                  <v-btn v-if="is_editing" small dense text type="submit" class="mx-2 btn-success" align="center" @click="submitClient()">
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar
                  </v-btn>
                  <v-btn small dense text :class="['mx-2 mt-2', all_filled? 'btn-contract' : '']" align="center" @click="sendContract()" v-if="!loading && !is_editing && all_filled" :disabled="!all_filled">
                    <v-icon left>mdi-file-sign</v-icon>
                    Solicitar contrato
                  </v-btn>
                  <div>
                    <span class="caption error--text text--lighten-2 mr-2" v-if="!all_filled && is_editing">*Preencha todos os dados abaixo para solicitar contrato</span>
                  </div>
                </v-col>
              </v-row>

              <v-row class="pa-0" v-if="false &&is_editing">
                <v-col cols='12' class="mx-2 pt-7 pb-0" align="right">
                  <v-btn v-if="is_editing" small tile type="submit" color="error" class="mx-2" align="center" @click="cancelEditing()">
                    <v-icon left>mdi-cancel</v-icon>
                    Cancelar
                  </v-btn>
                  <v-btn v-if="is_editing" small tile type="submit" color="success" class="mx-2" align="center" @click="submitClient()">
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar
                  </v-btn>
                </v-col>
              </v-row>
              <template v-if='!loading'>
                <v-row class="mx-2">
                <!-- <v-row :class="['mx-2', is_editing? 'pt-5' : 'pt-10']"> -->
                  <v-col cols="12" lg="12">
                    <v-card outlined class="mt-n4 pb-2">
                      <v-card-title class="primary--text text-subtitle-2 overline d-flex justify-space-between pb-2 mb-1">
                        <span :class="!is_editing ? 'grey--text' : ''" >Dados do Contratante</span>
                      </v-card-title>
                      <v-card-text class="pb-2">
                        <v-row>
                          <v-col cols='12' lg="6" md='6' sm='12' class="py-2">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.name" :label="`Nome${client.doc_kind == 'cpf'? '' : ' Fantasia'} do cliente`"></v-text-field>
                          </v-col>
                          <v-col cols='12' lg="3" md='3' sm='5' class="py-0 mt-n1">
                            <div class="d-flex justify-center">
                              <v-radio-group v-model="client.doc_kind" mandatory row>
                                <v-radio label="CPF" value="cpf"></v-radio>
                                <v-radio label="CNPJ" value="cnpj"></v-radio>
                              </v-radio-group>
                            </div>
                          </v-col>
                          <v-col cols='12' lg="3" md='3' sm='7' class="py-2">
                            <v-text-field :rules="required_cpf" dense class="mt-0 pt-n10" outlined v-model="client.document" v-if="client.doc_kind == 'cpf'" label="CPF" v-mask="cpfMask"></v-text-field>
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.document" v-if="client.doc_kind == 'cnpj'" v-mask="cnpjMask" label="CNPJ"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-if="client.doc_kind == 'cnpj'">
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_name" label="Razão Social"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_job" label="Cargo do assinante"></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row v-if="client.doc_kind == 'cpf'">
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_rg" label="RG"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_work" label="Profissão"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_filiation" label="Filiação"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_civil_state" label="Estado Civil"></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.phone" v-mask="phoneMask" label="Telefone"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.email" label="E-mail"></v-text-field>
                          </v-col>
                        </v-row>
                        
                        <v-card-title class="primary--text text-subtitle-2 overline justify-space-between pb-3 pl-0">
                          <span :class="!is_editing ? 'grey--text' : ''" >Endereço</span>
                        </v-card-title>
                        <v-row>
                          <v-col cols='12' sm='3' class="py-2">
                            <v-text-field :rules="required_zip" dense class="mt-0 pt-n10" outlined v-model="client.address.zip" v-mask="zipMask" @input="fetchZip(client.address.zip)" label="Cep"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-2">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.address.street" label="Rua"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='3' class="py-2">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.address.number" prefix="nº" label="Numero" type="number"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols='12' sm='4' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.address.district" label="Bairro"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='4' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.address.city" label="Cidade"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='4' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.address.state" label="Estado"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                    <v-card v-if="client.doc_kind == 'cnpj'" outlined class="my-3 pb-2">
                      <v-card-title class="primary--text text-subtitle-2 overline d-flex justify-space-between pb-3">
                        <span :class="!is_editing ? 'grey--text' : ''" >Dados do Representante</span>
                      </v-card-title>
                      <v-card-text class="pb-2">
                        <v-row class="pt-2">
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_name" label="Nome do representante"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_document" v-mask="cpfMask" label="CPF"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_phone" v-mask="phoneMask" label="Telefone"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_email" label="E-mail"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_rg" label="RG"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_work" label="Profissão"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_filiation" label="Filiação"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_civil_state" label="Estado Civil"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols='12' sm='3' class="py-2">
                            <v-text-field :rules="required_zip" dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_address_zip" v-mask="zipMask" @input="fetchZip(client.corporate_person_address_zip, false)" label="Cep"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='6' class="py-2">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_address_street" label="Rua"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='3' class="py-2">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_address_number" prefix="nº" label="Numero" type="number"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols='12' sm='4' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_address_district" label="Bairro"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='4' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_address_city" label="Cidade"></v-text-field>
                          </v-col>
                          <v-col cols='12' sm='4' class="py-0">
                            <v-text-field dense class="mt-0 pt-n10" outlined v-model="client.corporate_person_address_state" label="Estado"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <!-- <v-textarea dense outlined v-model="client.comment" label="Comentario" class="mt-5 mx-5"></v-textarea> -->
              </template>
              <card-loading-transparent v-if="loading"></card-loading-transparent>
            </v-form>
          </div>
        </template>
        <template slot="actions"> </template>
    </default-card>

    <dialog-loading v-if="saving"></dialog-loading>
  </div>
</template>

<script>
  import validations from "@/mixins/validations";
  import cep from 'cep-promise'
  import Api from '@/api'
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'FormEventClient',
    mixins: [ validations ],
    props: {
      is_component_show_event: {
        type: Boolean
      },
      is_component_create_event: {
        type: Boolean
      },
    },
    data() {
      return {
        loading: false,
        saving: false,
        is_editing: this.is_component_show_event ? false : this.is_component_create_event ? true : '',
        loading_zip: false,
        cpfMask: '###.###.###-##',
        cnpjMask: '##.###.###/####-##',
        zipMask: '##.###-###',
        phoneMask: '(##) # ####-####',
        valid: true,
        is_client_exist: false,
        loading_zip: false,
        client: {
          id: null,
          name: '',
          comment: '',
          doc_kind: '',
          document: '',
          phone: '',
          email: '',
          corporate_person_name: '',
          corporate_person_document: '',

          corporate_name: '',
          corporate_person_job: '',
          corporate_person_work: '',
          corporate_person_rg: '',
          corporate_person_filiation: '',
          corporate_person_civil_state: '',
          corporate_person_phone: '',
          corporate_person_email: '',
          corporate_person_address_zip: '',
          corporate_person_address_number: '',
          corporate_person_address_street: '',
          corporate_person_address_district: '',
          corporate_person_address_city: '',
          corporate_person_address_state: '',

          address: {
            zip : '',
            street : '',
            number : '',
            district : '',
            city : '',
            state : '',
          }
        }
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      sendContract(){
        console.log('SEND EMAIL');
        this.loading = true
        this.saving = true
        Api.Event.send_data_for_contract(this.$route.params.id).then(r=> r.data).then(d=>{
          // console.log({d});
          this.addNotification({type: 'success', msg: `Solicitação enviada com sucesso. Em alguns dias receberá o contrato em seu email!`})
        }).catch((err) => {
          let msg = `${err.response.status} - Ocorreu um erro.`
          if (err.response.data && err.response.data[0]){
            msg = err.response.data[0]
          }
          this.addNotification({type: 'error', msg})
          console.log({err});
        }).finally(()=>{
          this.saving = false
          this.loading = false
        })
      },
      cancelEditing(){
        this.is_editing = !this.is_editing
        this.getData()
      },
      enableEditing(){
        this.is_editing = !this.is_editing
      },
      submitClient(){
        this.loading = true
        this.is_editing = !this.is_editing
        if(this.is_client_exist){
          this.updateClient()
        }else{
          this.createClient()
        }
      },
      updateClient(){
        Api.EventClient.update(this.client).then(r=>r.data).then(d=>{
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{
          setTimeout(()=>{
            this.loading = false
          },600)
        })
      },
      createClient(){
        let update_client = {}
        Api.EventClient.create({event_id: this.$route.params.id, ...this.client}).then(r=>r.data).then(d=>{
          update_client = {...d}
        }).catch(err=>{
          console.log(err);
        }).finally(()=>{
          this.client = {...this.client, ...update_client}
          this.is_client_exist = true
          setTimeout(()=>{
            this.loading = false
          },600)
        })
      },
      getData(){
        if(this.$route.params.id){
          //let id = this.$route.params.id
          this.loading = true
          let filter = {
          }
          Api.EventClient.indexByEvent({event_id: this.$route.params.id , filter}).then(r=>r.data).then(d=>{
            if(d[0] != undefined){
              this.client = {
                address: d[0].json_attributes.address,
                ...d[0]
              }
              this.is_client_exist = true
            }else{
              this.is_client_exist = false
            }
            this.loading = false
          })
        }
      },
      fetchZip(zip, is_client = true) {
        if(this.is_editing && !this.loading_zip && (/^[0-9]{8}$/.test(zip.replace(/[.-]/g,'')))) {
          this.loading_zip = true
          cep(zip.replace(/[.-]/g,'')).then(endereco => {
            const { street, neighborhood, city, state, cep } = endereco
            if (is_client){
              this.client.address = {
                ...this.client.address,
                street : street,
                district : neighborhood,
                city : city,
                state : state,
              }
            } else {
              this.client.corporate_person_address_street = street
              this.client.corporate_person_address_district = neighborhood
              this.client.corporate_person_address_city = city
              this.client.corporate_person_address_state = state
            }
          }).finally(()=>{
            this.loading_zip = false
          })
        }
      },
      ...mapActions({
        setActiveCompanyId: 'App/setActiveCompanyId',
        addNotification: 'Notification/add',
      })
    },
    computed: {
      full_address_comp(){
        let address = {...this.client.address}
        let full = null
        if (address.street && address.number && address.state && address.city && address.zip && address.district){
          full = `${address.street}, ${address.number} - ${address.district}, ${address.city} - ${address.state}, ${address.zip}`
        }
        return full
      },
      all_filled(){
        let all = true
        if (this.client){
          all = all && this.client.id &&
          this.client.name &&
          this.client.doc_kind &&
          this.client.document &&
          this.client.phone &&
          this.client.email &&
          this.client.corporate_person_work &&
          this.client.corporate_person_rg &&
          this.client.corporate_person_filiation &&
          this.client.corporate_person_civil_state &&
          this.client.address.zip &&
          this.client.address.street &&
          this.client.address.number &&
          this.client.address.district &&
          this.client.address.city &&
          this.client.address.state

          if (this.client.doc_kind == 'cnpj'){
            all = all && this.client.corporate_name &&
            this.client.corporate_person_name &&
            this.client.corporate_person_document &&
            this.client.corporate_person_job &&
            this.client.corporate_person_phone &&
            this.client.corporate_person_email &&
            this.client.corporate_person_address_zip &&
            this.client.corporate_person_address_number &&
            this.client.corporate_person_address_street &&
            this.client.corporate_person_address_district &&
            this.client.corporate_person_address_city &&
            this.client.corporate_person_address_state
          } 
        }
        return !!all
      },
    },
    watch: {
      'client.doc_kind'(nv,ov) {
        if (nv == 'cpf'){
          // this.client.corporate_person_work = ''
          // this.client.corporate_person_rg = ''
          // this.client.corporate_person_filiation = ''
          // this.client.corporate_person_civil_state = ''
          this.client.corporate_name = ''
          this.client.corporate_person_name = ''
          this.client.corporate_person_document = ''
          this.client.corporate_person_job = ''
          this.client.corporate_person_phone = ''
          this.client.corporate_person_email = ''
          this.client.corporate_person_address_zip = ''
          this.client.corporate_person_address_number = ''
          this.client.corporate_person_address_street = ''
          this.client.corporate_person_address_district = ''
          this.client.corporate_person_address_city = ''
          this.client.corporate_person_address_state = ''
        } else if (nv == 'cnpj'){
          
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>